import { useAuth, useRequest } from "@onefront/react-sdk";
import { useEffect, useState } from "react";
import { buildHeaders } from "../../common-utils/buildHeaders";
import { useClientInformationStore } from "../../store/useClientInformationStore";
import { useDocumentList } from "../../document-page/state/useDocumentList";

export function useDeleteMultipleDocuments(
  docIdDelete,
  workspaceId,
  confirm,
  setOpenModalDelete,
  setConfirm
) {
  const authData = useAuth();
  const { selectedTenant: currentCompany } = useClientInformationStore();
  const clientId = currentCompany?.itemId;
  const { documentFilterOption, toggleLoading } = useDocumentList();

  const { data, loading, hasLoaded, fetch, error } = useRequest({
    method: "delete",
    lazy: true,
    headers: buildHeaders({ authData }),
    url: `documentsApi://api/v1/documents/deleteMultiple?workspaceId=${workspaceId}`,
    data: {
      documentsId: docIdDelete,
    },
  });
  useEffect(() => {
    if (docIdDelete && docIdDelete.length > 0 && confirm) {
      if (documentFilterOption === "CESTINO") {
        fetch();
        toggleLoading();
        setOpenModalDelete(false);
        setConfirm(false);
      }
    }
  }, [docIdDelete, confirm]);
  const [responseData, setResponseData] = useState(null);
  useEffect(() => {
    if (hasLoaded) {
      toggleLoading();
      setResponseData(data);
    }
  }, [hasLoaded]);

  return { data: responseData, loading, hasLoaded, fetch, error };
}
